import { r2PaletteColors } from '../layout/themes'
import indigo from '@material-ui/core/colors/indigo';
import blue from '@material-ui/core/colors/blue';

import { Cancel, CheckCircle, AccessTime, FastRewind, Close, Done, Block, AddCircle } from '@material-ui/icons';


export const getFinancingTypes = () => [
    { id: 'new', name: 'resources.Financing.types.new', color: indigo[200] },
    { id: 'refill', name: 'resources.Financing.types.refill', color: indigo[400] },
    { id: 'repeat', name: 'resources.Financing.types.repeat', color: blue[400] },
    { id: 'restructure', name: 'resources.Financing.types.restructure', color: blue[200] },
]

export const getFinancingStates = () => [
    // { id: "DEFAULT", name: "resources.Financing.states.default", color: r2PaletteColors.blue },
    { id: "NEW", name: "resources.Financing.states.new", color: r2PaletteColors.green, icon: AddCircle },
    { id: 'ACTIVE', name: 'resources.Financing.states.active', color: r2PaletteColors.blue, icon: CheckCircle },
    { id: 'ON_TIME', name: 'resources.Financing.states.onTime', color: r2PaletteColors.purple, icon: CheckCircle },
    { id: 'DELAYED', name: 'resources.Financing.states.delayed', color: r2PaletteColors.yellow, icon: AccessTime },
    { id: 'SLOW', name: 'resources.Financing.states.slow', color: r2PaletteColors.purple, icon: FastRewind },
    { id: 'OVERDUE', name: 'resources.Financing.states.overdue', color: r2PaletteColors.red, icon: Close },
    { id: 'CHARGED_OFF', name: 'resources.Financing.states.chargedOff', color: r2PaletteColors.brown, icon: Block },
    { id: 'PAID', name: 'resources.Financing.states.paid', color: r2PaletteColors.black, icon: Done },
    { id: 'CANCELLED', name: 'resources.Financing.states.cancelled', color: r2PaletteColors.red, icon: Cancel },
]